import {
  Button,
  LinearProgress,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Input,
} from "@material-ui/core";
// import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas';
import CloseIcon from "@material-ui/icons/Close";
// import 'jspdf-autotable'; // For tables

// import autoTable from 'jspdf-autotable';
// import { format } from 'date-fns';


import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import * as format from "date-fns/format";
import * as React from "react";

import ReactPaginate from "react-paginate";
import {
  ICoach,
  IScaleQuestionAndResponse,
  ISport,
  ISurveyEvaluationRequest,
  ISurveyEvaluationResponse,
  ISurveyEvaluationResponses,
  IWrittenQuestionAndResponse,
  IWrittenResponse,
  TemplateQuestionCategory,
} from "src/api/types";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import Component from "src/shared/components/Component";
import Modal, { IModalProps } from "src/shared/components/Modal";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import l from "src/l";
import { roundToTen } from "src/util";
import {
  CANCEL_TEXT,
  DELETE_TEXT,
  GET_DELETE_CONFIRMATION_TEXT,
} from "./constants";
import "./pagination.css";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getCurrentStudentNameMask } from "src/api/client";



const styles = (theme: Theme): Record<string, CSSProperties> => ({
  modal: {
    height: "80%",
    width: "80%",
  },
  summaryBox: {
    backgroundColor: "#efefef",
    border: "1px solid #424242",
    borderRadius: 4,
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px ${theme.spacing(
      1
    )}px ${theme.spacing(1)}px`,
  },
  text: {
    overflowWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
});


interface IExtraProps {
  slug: string;
  schoolId: number;
  surveyId: number;
  coach: ICoach;
  sport: ISport;
  startDate: number;
  endDate: number;
  isParentModal?: "true" | "false";
  schoolData: any
}


type IBaseProps = IModalProps & IExtraProps;


type IProps = IBaseProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;


interface ISurveyResponsesModalState {
  loading?: true;
  index: number;
  surveyResponse?: ISurveyEvaluationResponses;
  showDeleteConfirmation?: true;
  isDeleting?: true;
  selectedIndices: number[];
  isGeneratingPDF?: boolean;
  studentNameMask: boolean;
  studentNameMaskLoaded: boolean;
}


export default withStyles(styles, { withTheme: true })(

  withAxios(
    class CoachResponsesModal extends Component<
      IProps,
      ISurveyResponsesModalState
    > {
      public readonly state = this.buildState({
        index: 0,
        selectedIndices: [],
        isGeneratingPDF: false,
        studentNameMask: true,
        studentNameMaskLoaded: false,
      });

      public componentDidMount() {
        void this.loadStudentNameMaskSetting();
        void this.loadAsync();
      }

      // public render() {
      //   const { open, classes } = this.props;
      //   return (
      //     <Modal
      //       open={open}
      //       closeModal={this.props.closeModal}
      //       className={classes.modal}
      //     >
      //       {this.renderResponses()}
      //     </Modal>
      //   );
      // }

      public render() {
        const { open, classes } = this.props;
        return (
          <Modal
            open={open}
            closeModal={this.props.closeModal}
            className={classes.modal}
          >
            {/* ⭐ ADD LOADING OVERLAY HERE ⭐ */}
            {this.state.isGeneratingPDF && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.5)",
                  zIndex: 9999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <CircularProgress size={60} style={{ color: "#1976d2" }} />
                <div style={{
                  color: "#fff",
                  fontSize: 22,
                  marginTop: 24,
                  textAlign: "center",
                  padding: "0 20px"
                }}>
                  Creating your PDF... Please wait and don’t close this window.         
                   </div>
              </div>
            )}
            {/* ⭐ END LOADING OVERLAY ⭐ */}

            {this.renderResponses()}
          </Modal>
        );
      }

      private renderResponses() {
        const { loading, surveyResponse } = this.state;
        console.log("surveyResponse333333", surveyResponse)
        if (loading) {
          return <LinearProgress variant="query" />;
        }
        if (surveyResponse === undefined) {
          return <span>Oops... something went wrong</span>;
        }
        return <div>{this.renderData(surveyResponse)}</div>;
      }


      private renderData(surveyResponse: ISurveyEvaluationResponses) {
        const { isParentModal = "false" } = this.props;
        console.log("surveyResponse", surveyResponse.surveyResponses)
        return (
          <div>
            {this.renderHeader()}

            {/* {this.renderPaginationWithCheckboxes(surveyResponse)} */}
            {isParentModal === "false" ?
              this.renderPaginationWithCheckboxes(surveyResponse) : ""}

            <div
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                paddingTop: "15px",
                marginBottom: "15px",
              }}
            >
              {this.renderPagination(surveyResponse)}

              {surveyResponse.surveyResponses.length === 0 && (
                <h1 style={{ color: "red" }}>There are 0 {isParentModal === "true"
                  ? "Parent"
                  : this.props?.schoolData?.isAdSurvey === true ? "Coach" : "Student"} responses</h1>
              )}


              {this.renderDelete(surveyResponse)}


            </div>

            {this.renderRespondentName(surveyResponse)}
            <Table>
              {isParentModal === "true" ? (
                <>
                  {this.renderScaleQuestionsCategory(
                    this.filterScaleCategory(
                      surveyResponse.scaleSurveyQuestionResponses,
                      TemplateQuestionCategory.parent
                    ),
                    "Parent Responses",
                    surveyResponse.surveyResponses
                  )}
                </>
              ) : (
                <>
                  <div style={{ marginTop: "1.25rem" }}>
                    {this.renderScaleQuestionsCategory(
                      this.filterScaleCategory(
                        surveyResponse.scaleSurveyQuestionResponses,
                        TemplateQuestionCategory.expectations
                      ),
                      "Expectations",
                      surveyResponse.surveyResponses
                    )}
                  </div>
                  <div style={{ marginTop: "1.25rem" }}>
                    {this.renderScaleQuestionsCategory(
                      this.filterScaleCategory(
                        surveyResponse.scaleSurveyQuestionResponses,
                        TemplateQuestionCategory.warmth
                      ),
                      "Relational Warmth",
                      surveyResponse.surveyResponses
                    )}
                  </div>
                  <div style={{ marginTop: "1.25rem" }}>
                    {this.renderScaleQuestionsCategory(
                      this.filterScaleCategory(
                        surveyResponse.scaleSurveyQuestionResponses,
                        TemplateQuestionCategory.other
                      ),
                      "Written Response",
                      surveyResponse.surveyResponses
                    )}
                  </div>
                </>
              )}
            </Table>

            <div style={{ marginTop: "1.25rem" }}>
              {this.renderWrittenQuestions(
                surveyResponse.writtenQuestionsResponses,
                surveyResponse.surveyResponses
              )}
            </div>

            <div style={{ marginTop: "1.25rem" }}>
              {this.renderRespondentName(surveyResponse)}
              {this.renderPagination(surveyResponse)}
            </div>
          </div>
        );
      }

      private renderHeader() {
        const { coach, sport, startDate, endDate } = this.props;
        const sportName = this.props?.schoolData?.isAdSurvey === true
          ? "Athletic Director"
          : sport.name.trim();
        return (
          <span>
            <Typography variant="h3">
              {coach.name.trim()}{this.props?.schoolData?.isEmbeddable === true ? "" : `: ${sportName}`}
            </Typography>
            <Typography variant="h3">{`${format(
              startDate,
              "MMMM D, YYYY"
            )} to ${format(endDate, "MMMM D, YYYY")}`}</Typography>
          </span>
        );
      }

      private readonly loadStudentNameMaskSetting = async () => {
        try {
          this.setState({
            studentNameMask: await getCurrentStudentNameMask(
                Number(this.props.schoolId)
            ),
            studentNameMaskLoaded: true,
          });
        } catch (error) {
          console.error("Failed to load student name masking setting", error);
          this.setState({
            studentNameMask: true,
            studentNameMaskLoaded: true,
          });
        }
      };

      private isStudentNameMasked = (): boolean =>
        !this.state.studentNameMaskLoaded || this.state.studentNameMask;

      private getDisplayedRespondentName = (respondentName: string): string =>
        this.isStudentNameMasked() ? "Respondent" : respondentName;

      private renderRespondentName(surveyResponse: ISurveyEvaluationResponses) {
        const { index } = this.state;
        if (this.isStudentNameMasked()) {
          return null;
        }
        if (surveyResponse.surveyResponses[index] === undefined) {
          return <div>no respondent</div>;
        }
        return (
          <div>
            <Typography>
              <strong> Respondent Name:{" "} </strong>

              {surveyResponse.surveyResponses[index].respondentName}

            </Typography>
          </div>
        );
      }



      private renderDelete(surveyResponse: ISurveyEvaluationResponses) {
        const { index, showDeleteConfirmation, isDeleting, selectedIndices } = this.state;
        const { isParentModal = "false" } = this.props;
        if (surveyResponse.surveyResponses[index] === undefined) {
          return;
        }

        if (selectedIndices.length === 0 && isParentModal === "false") {

          // alert("Please select at least one response to delete!");
          // return;
        }

        // console.log("showDeleteConfirmation", showDeleteConfirmation)
        // console.log("selectedIndices", selectedIndices)
        // Get selected respondent names for confirmation message

        return (
          <>
            {showDeleteConfirmation ? (
              <div style={{ padding: "0.25rem" }}>

                <Dialog open={true} >
                  <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontWeight: "600",
                    padding: "10px 15px",
                  }} >
                    <DialogTitle style={{ padding: "0", }}>
                      Confirm Delete

                    </DialogTitle>
                    <IconButton
                      aria-label="close"
                      onClick={this.showDeleteConfirmation(undefined)}
                      size="small"
                      style={{ color: "#888" }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <DialogContent style={{ padding: "0 15px 5px 15px" }}>
                    {isParentModal === "true" ? <p>
                      {GET_DELETE_CONFIRMATION_TEXT(this.getDisplayedRespondentName(
                        surveyResponse.surveyResponses[index].respondentName
                      ))}
                    </p> :

                      <p>
                        Are you sure you would like to delete{" "}
                        {selectedIndices.length === 1
                          ? `this response from 1 respondent?`
                          : `these responses from ${selectedIndices.length} respondents?`}
                      </p>

                    }
                  </DialogContent>
                  <div
                    style={{
                      display: "grid",
                      gridGap: "1rem",
                      gridTemplateColumns: "1fr 1fr",
                      padding: "0 15px 10px 15px",
                    }}
                  >
                    {isParentModal === "true" ? <Button
                      onClick={this.deleteSurveyResponse(
                        surveyResponse.surveyResponses[index].id
                      )}
                      variant="contained"
                      color="secondary"
                    >
                      {DELETE_TEXT}
                    </Button> :
                      <Button

                        onClick={this.deleteSurveyResponseArray(surveyResponse, selectedIndices)}
                        variant="contained"
                        color="secondary"
                      >
                        {DELETE_TEXT}
                      </Button>}



                    <Button className="border" onClick={this.showDeleteConfirmation(undefined)}>
                      {CANCEL_TEXT}
                    </Button>
                  </div>
                </Dialog>
              </div>
            ) : (
              <div style={{ display: "flex", gap: "10px", margin: "0", justifyContent: "space-between" }}>
                {isParentModal === 'false' ? this.renderPrintButton() : ""}
                {isDeleting && <LinearProgress />}
                <Button
                  style={{ backgroundColor: "#be0000", color: "white" }}
                  // onClick={this.showDeleteConfirmation(true)}

                  onClick={() => {
                    if (selectedIndices.length === 0 && isParentModal === "false") {
                      alert("Please select a respondent from the dropdown menu before continuing.");
                      // return;
                    } else {
                      this.showDeleteConfirmation(true)();

                    }
                  }}
                >
                  Delete
                </Button>
              </div>
            )}
          </>
        );
      }

      private readonly showDeleteConfirmation =
        (show: true | undefined) => () =>
          this.setState({ showDeleteConfirmation: show });




      private deleteSurveyResponseArray = (
        surveyResponse: ISurveyEvaluationResponses,
        selectedIndices: any
      ) => async () => {
        try {
          console.log("surveyResponseArray", surveyResponse.surveyResponses);
          console.log("selectedIndices", selectedIndices);

          if (!selectedIndices || selectedIndices.length === 0) {
            console.log("No indices selected for deletion.");
            return;
          }

          // Perform all deletions in parallel
          await Promise.all(
            selectedIndices.map((i: number) => {
              const id = surveyResponse.surveyResponses[i]?.id;
              if (id) {
                console.log("Deleting surveyResponseId:", id);
                return this.deleteSurveyResponse(id)(); // call the delete function
              }
              return Promise.resolve(); // skip invalid indices
            })
          );

          // Once all deletions are done — clear selectedIndices
          this.setState({ selectedIndices: [] }, () => {
            console.log("All deletions complete. State cleared.");
            // Optional: force re-render if UI doesn't update automatically
            // this.forceUpdate();
          });
        } catch (error) {
          console.error("Error deleting survey responses:", error);
        }
      };


      private deleteSurveyResponse = (surveyResponseId: number) => async () => {
        const { surveyId, schoolId } = this.props;
        console.log("surveyId", surveyId);
        await this.runCancellableStatefulAsync(
          this,
          {
            isDeleting: true,
          },
          {
            isDeleting: undefined,
            showDeleteConfirmation: undefined,
          },
          async () => {
            const { surveyResponse } = this.state;
            await this.buildDeleteWithParams<{}, { schoolId: number }>(
              this,
              l`survey/${surveyId}/${surveyResponseId}`
            )({
              schoolId,
            });
            await this.buildDeleteWithParams<any, any>(
              this,
              l`survey/delete/${surveyId}`
            );
            await this.loadAsync();
            if (surveyResponse === undefined) {
              return;
            }
            console.log(
              " I am making the index right",
              Math.min(
                this.state.index,
                surveyResponse.surveyResponses.length - 1
              )
            );
            this.setState((prevState) => {
              return {
                index: Math.max(
                  0,
                  Math.min(
                    prevState.index,
                    surveyResponse.surveyResponses.length - 2
                  )
                ),
              };
            });
          },
          () => {
            this.setState({ isDeleting: undefined });
            window.alert("Failed to delete survey response.");
          }
        );
      };

      private renderPagination(surveyResponse: ISurveyEvaluationResponses) {
        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <nav style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <ReactPaginate
                forcePage={this.state.index}
                pageCount={surveyResponse.surveyResponses.length}
                previousLabel={"previous"}
                nextLabel={"next"}
                breakClassName={"pagination-break"}
                marginPagesDisplayed={1}
                pageRangeDisplayed={15}
                containerClassName={"pagination"}
                activeClassName={"active"}
                onPageChange={this.onSurveyRespondChange}
              />
            </nav>
          </div>
        );
      }



      private renderPaginationWithCheckboxes(surveyResponse: ISurveyEvaluationResponses) {
        const { selectedIndices } = this.state;

        return (
          <div className="select-print-wrapper">


            <style>
              {`  
          .select-print-wrapper {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            gap: 10px;
            position: relative;
          }
          
          .select-print-wrapper .print-btn-wrapper {
            display: none;
          }
          
          .respondents-select-wrapper {
            width: 44.5%;
            margin-top: 5px;
          }

          .select-all-menu-item {
            border-bottom: 1px solid #e0e0e0;
            background-color: #f5f5f5;
          }

          .select-all-menu-item:hover {
            background-color: #eeeeee !important;
          }
        `}
            </style>

            <div className="respondents-select-wrapper">
              <FormControl fullWidth={true}>
                <InputLabel id="respondents-select-label">Select Respondents</InputLabel>
                <Select
                  labelId="respondents-select-label"
                  id="respondents-select"
                  multiple={true}
                  value={this.state.selectedIndices}
                  onChange={this.handleDropdownChange}
                  input={<Input />}
                  renderValue={(selected) => {
                    if ((selected as number[]).length === 0) {
                      return <em>None selected</em>;
                    }
                    return `${(selected as number[]).length} respondent(s) selected`;
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                      },
                    },
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                  }}
                >
                  {/* Select All option inside dropdown */}
                  <MenuItem
                    className="select-all-menu-item"
                    onClickCapture={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.handleSelectAllFromDropdown(surveyResponse.surveyResponses.length);
                    }}
                  >
                    <Checkbox
                      checked={selectedIndices.length === surveyResponse.surveyResponses.length && surveyResponse.surveyResponses.length > 0}
                      indeterminate={selectedIndices.length > 0 && selectedIndices.length < surveyResponse.surveyResponses.length}
                      color="primary"
                    />
                    <ListItemText
                      primary="Select All"
                      primaryTypographyProps={{ style: { fontSize: '14px', fontWeight: 'bold' } }}
                    />
                  </MenuItem>

                  {surveyResponse.surveyResponses.map((response, idx) => (
                    <MenuItem key={idx} value={idx}>
                      <Checkbox
                        checked={this.state.selectedIndices.includes(idx)}
                        color="primary"
                      />
                      <ListItemText
                        primary={`${idx + 1}. ${this.getDisplayedRespondentName(response.respondentName)}`}
                        primaryTypographyProps={{ style: { fontSize: '14px' } }}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {this.renderPrintButton()}
          </div>
        );
      }

      private handleDropdownChange = (
        event: React.ChangeEvent<{ value: unknown }>
      ) => {
        const selectedIndices = (event.target.value as number[]).sort(
          (a, b) => a - b
        );

        this.setState({ selectedIndices });
      };



      private handleSelectAllFromDropdown = (totalResponses: number) => {
        console.log("handleSelectAllFromDropdown", totalResponses);
        const { selectedIndices } = this.state;
        console.log("selectedIndices", selectedIndices);
        console.log("selectedIndices length", selectedIndices.length);

        if (selectedIndices.length === totalResponses) {
          // If all are selected, deselect all
          console.log("Deselecting all");
          this.setState({ selectedIndices: [] }, () => {
            // Force a re-render after state update
            this.forceUpdate();
          });
        } else {
          // Select all
          const allIndices = Array.from({ length: totalResponses }, (_, i) => i);
          console.log("Selecting all", allIndices);
          this.setState({ selectedIndices: allIndices }, () => {
            // Force a re-render after state update
            this.forceUpdate();
          });
        }
      };
      private onSurveyRespondChange = (data: { selected: number }) => {
        console.log("data123", data);
        console.log("data.selected", data.selected);
        this.setState({
          index: data.selected,
          showDeleteConfirmation: undefined,
        });
      };

      private renderScaleQuestionsCategory(
        data: IScaleQuestionAndResponse[],
        heading: string,
        surveyResponses: ISurveyEvaluationResponse[]
      ) {
        const { classes } = this.props;
        const { index } = this.state;
        if (data.length === 0) {
          return null;
        }
        return (
          <>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "100%" }}>
                  <Typography variant="h4" style={{ fontWeight: "bold" }}>
                    {heading}
                  </Typography>
                </TableCell>
                <TableCell>Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((d, i: number) => {
                const getText = () => {
                  if (surveyResponses[index] === undefined) {
                    return;
                  }
                  const response = d.responses.find(
                    (dr) => dr.surveyResponseId === surveyResponses[index].id
                  );
                  if (response === undefined) {
                    return;
                  }
                  return roundToTen(response.response);
                };
                return (
                  <TableRow key={i}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.text}
                    >
                      {d.question.text}
                    </TableCell>
                    <TableCell>{getText()}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </>
        );
      }

      private renderWrittenQuestions(
        data: IWrittenQuestionAndResponse[],
        surveyResponses: ISurveyEvaluationResponse[]
      ) {
        return (
          <div>
            {data.map(
              (d, i) =>
                d.question.text &&
                this.renderWrittenQuestion(d, i, surveyResponses)
            )}
          </div>
        );
      }

      private renderWrittenQuestion(
        d: IWrittenQuestionAndResponse,
        i: number,
        surveyResponses: ISurveyEvaluationResponse[]
      ) {
        const { classes } = this.props;
        const { index } = this.state;

        return (
          <div key={i} style={{ marginTop: "0.5rem" }}>
            <div className={`${classes.text}`}>{d.question.text}</div>
            <div className={`${classes.text} ${classes.summaryBox}`}>
              {(() => {
                if (surveyResponses[index] === undefined) {
                  return;
                }
                return this.renderWrittenResponse(
                  d.responses.find(
                    (dr) => dr.surveyResponseId === surveyResponses[index].id
                  )
                );
              })()}
            </div>
          </div>
        );
      }

      private renderWrittenResponse(d: IWrittenResponse | undefined) {
        if (d === undefined) {
          return;
        }
        return <div>{d.response}</div>;
      }

      private filterScaleCategory(
        data: IScaleQuestionAndResponse[],
        category: number
      ) {
        return data.filter((d) => d.question.category === category);
      }

      // ============= PDF GENERATION WITH html2pdf =============

      private renderPrintButton() {
        const { surveyResponse, selectedIndices, isGeneratingPDF } = this.state;

        if (!surveyResponse || surveyResponse.surveyResponses.length === 0) {
          return null;
        }

        return (
          <div className="print-btn-wrapper">
            <Button
              onClick={this.handleGeneratePDF(selectedIndices, 'open')}
              variant="contained"
              color="primary"
            // disabled={selectedIndices.length === 0 || isGeneratingPDF}
            >
              {/* {isGeneratingPDF ? '⏳ Generating PDF...' : `Print  (${selectedIndices.length}) `} */}
              {isGeneratingPDF ? 'Generating PDF...' : `Print `}
            </Button>

            {/* <Button
              onClick={this.handleGeneratePDF([this.state.index], 'open')}
              variant="contained"
              style={{ backgroundColor: '#4caf50', color: 'white' }}
              disabled={isGeneratingPDF}
            >
              {isGeneratingPDF ? '⏳ Generating...' : '📄 Open Current Response'}
            </Button>

            <Button
              onClick={this.handleGeneratePDF(selectedIndices, 'download')}
              variant="outlined"
              color="primary"
              disabled={selectedIndices.length === 0 || isGeneratingPDF}
            >
              {isGeneratingPDF ? '⏳ Downloading...' : `⬇️ Download PDF (${selectedIndices.length})`}
            </Button>

            <Typography variant="body2" style={{ marginLeft: '10px', color: '#666' }}>
              {selectedIndices.length === 0 
                ? 'Select responses from dropdown to generate PDF' 
                : `Ready to generate PDF with ${selectedIndices.length} response(s)`}
            </Typography> */}
            <style>
              {`
                .print-btn-wrapper{
                     margin: 0;
                    display: flex;
                    gap: 10px;
                    align-items: center;
                    flex-wrap: wrap;
                }

               `}
            </style>
          </div>
        );
      }


      // ============================================
      // SOLUTION 2: Chunked Processing (BEST PERFORMANCE)
      // ============================================
      // Breaks content into manageable chunks
      // Helper to preload logo image
      // Helper to preload logo image
      // private preloadLogoImage = (): Promise<HTMLImageElement> => {
      //   return new Promise((resolve, reject) => {
      //     const img = new Image();
      //     img.crossOrigin = 'anonymous';
      //     img.onload = () => resolve(img);
      //     img.onerror = reject;
      //     img.src = 'https://gritdev.s3.us-east-2.amazonaws.com/admin/image17380446332194438';
      //   });
      // }


      private handleGeneratePDF = (indices: number[], action: 'open' | 'download' = 'open') => async () => {
        console.log("testing 668", this.state);
        console.log("testing 669", this.props);

        const { surveyResponse } = this.state;
        const { coach, schoolData, startDate, endDate } = this.props;

        if (!surveyResponse || indices.length === 0) {
          alert("Please select a respondent from the dropdown menu before continuing.");
          return;
        }

        this.setState({ isGeneratingPDF: true });

        try {

          const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            // format: 'a4'
            format: [210, 350]
          });

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const marginBottom = 10;
          const contentHeight = pageHeight - marginBottom - 10;

          // Process each response separately
          for (let i = 0; i < indices.length; i++) {
            const idx = indices[i];
            const currentResponse = surveyResponse.surveyResponses[idx];

            const sections = this.buildResponseSections(surveyResponse, idx, currentResponse);
            const expectationsSection = sections.find(s => s.name === 'expectations');
            const warmthSection = sections.find(s => s.name === 'warmth');
            const writtenSection = sections.find(s => s.name === 'written');
            const otherSection = sections.find(s => s.name === 'other');
            const parentSection = sections.find(s => s.name === 'parent');

            if (i === 0) {
              // ROUND 1: Header + Respondent + Expectations + Warmth (same page)
              const { sport } = this.props;
              const headerHtml = this.buildHeaderContent(coach, startDate, endDate, sport, schoolData);
              const respondentHtml = this.buildRespondentHeader(this.getDisplayedRespondentName(currentResponse.respondentName));
              const expectationsHtml = expectationsSection?.html || '';
              const warmthHtml = warmthSection?.html || '';

              const combinedHtml = `
          <div style="padding: 0;">
            ${headerHtml}
            ${respondentHtml}
            ${expectationsHtml}
            ${warmthHtml}
          </div>
        `;
              await this.addSectionToPDF(pdf, combinedHtml, pageWidth, contentHeight, true);

              // Add other section if exists (same page logic as warmth)
              if (otherSection?.html) {
                // If you want "other" on a new page, add: pdf.addPage();
                // Otherwise it stays on same page as above
              }

              // Add parent section if exists
              if (parentSection?.html) {
                pdf.addPage();
                await this.addSectionToPDF(pdf, parentSection.html, pageWidth, contentHeight, false);
              }

              // Written Responses on NEW PAGE
              if (writtenSection?.html) {
                pdf.addPage();
                await this.addSectionToPDF(pdf, writtenSection.html, pageWidth, contentHeight, false);
              }

            } else {
              // ROUND 2+: New page with Respondent + Expectations + Warmth
              pdf.addPage();
              const respondentHtml = this.buildRespondentHeader(this.getDisplayedRespondentName(currentResponse.respondentName));
              const expectationsHtml = expectationsSection?.html || '';
              const warmthHtml = warmthSection?.html || '';

              const combinedHtml = `
          <div style="padding: 0;">
            ${respondentHtml}
            ${expectationsHtml}
            ${warmthHtml}
          </div>
        `;
              await this.addSectionToPDF(pdf, combinedHtml, pageWidth, contentHeight, false);

              // Add other section if exists
              if (otherSection?.html) {
                // Same page or new page based on your preference
                // For new page: pdf.addPage();
                // await this.addSectionToPDF(pdf, otherSection.html, pageWidth, contentHeight, false, logoImage);
              }

              // Add parent section if exists
              if (parentSection?.html) {
                pdf.addPage();
                await this.addSectionToPDF(pdf, parentSection.html, pageWidth, contentHeight, false);
              }

              // Written Responses on NEW PAGE
              if (writtenSection?.html) {
                pdf.addPage();
                await this.addSectionToPDF(pdf, writtenSection.html, pageWidth, contentHeight, false);
              }
            }
          }

          // const base64Image = logoImage;
          const base64Image = "data:image/png;base64,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"; // shortened for clarit

          // Add page numbers to all pages
          const totalPages = pdf.internal.pages.length - 1;
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(9);
            pdf.setTextColor(128, 128, 128);
            // pdf.text(
            //   `Page ${i} of ${totalPages}`,
            //   pageWidth / 2,
            //   pageHeight - 5,
            //   { align: 'center' }
            // );

            const imgWidth = 8;
            const imgHeight = 8;
            const x = (pageWidth - imgWidth) / 2;
            const y = pageHeight - imgHeight - 10;
            pdf.addImage(base64Image, "PNG", x, y, imgWidth, imgHeight);
          }

          const filename = `Survey_Report_${coach.name}_${format(startDate, "yyyy-MM-dd")}.pdf`;

          if (action === 'download') {
            // alert("PDF generated successfully. Your download will start shortly.");
            pdf.save(filename);
          }
          else {
            // alert("PDF generated successfully. It will open in a new tab.");

            const pdfBlob = pdf.output('blob');
            const blobUrl = URL.createObjectURL(pdfBlob);
            window.open(blobUrl, '_blank');
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl);
            }, 50001);
          }


          this.setState({ isGeneratingPDF: false });
        } catch (error) {
          console.error("PDF generation error:", error);
          alert("Failed to generate PDF. Please try again.");
          this.setState({ isGeneratingPDF: false });
        }
      }

      // Updated helper with logo parameter
      private addSectionToPDF = async (
        pdf: jsPDF,
        htmlContent: string,
        pageWidth: number,
        contentHeight: number,
        isFirstPage: boolean,
      ) => {
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.left = '-9999px';
        container.style.width = '190mm';
        container.style.padding = '0mm';
        container.style.paddingBottom = '35mm';
        container.style.backgroundColor = 'white';
        container.style.fontFamily = 'Arial, sans-serif';

        container.innerHTML = htmlContent;



        document.body.appendChild(container);

        // Wait longer for rendering
        await new Promise(resolve => setTimeout(resolve, 200));

        const canvas = await html2canvas(container, {
          scale: 2,
          useCORS: true,
          allowTaint: true,
          logging: false,
          backgroundColor: '#ffffff'
        });

        document.body.removeChild(container);

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const imgWidth = pageWidth - 20;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(
          imgData,
          'JPEG',
          10,
          10,
          imgWidth,
          Math.min(imgHeight, contentHeight),
          undefined,
          'FAST'
        );
      }



      private buildHeaderContent = (
        coach: any,
        startDate: Date | number | string,
        endDate: Date | number | string,
        sport: any,
        schoolData: any
      ): string => {
        // ✅ Debug karo - yeh dekho ki kya aa raha hai
        console.log('startDate:', startDate, typeof startDate);
        console.log('endDate:', endDate, typeof endDate);

        // ✅ Helper to safely convert to Date object
        const toDate = (v: Date | number | string): Date | null => {
          if (v === null || v === undefined) {
            return null;
          }

          let date: Date;

          if (v instanceof Date) {
            date = v;
          } else if (typeof v === "number") {
            date = new Date(v);
          } else if (typeof v === "string") {
            const num = Number(v);
            date = !isNaN(num) ? new Date(num) : new Date(v);
          } else {
            return null;
          }

          return !isNaN(date.getTime()) ? date : null;
        };

        // Convert and validate dates
        const start = toDate(startDate);
        const end = toDate(endDate);

        // ✅ Yeh bhi check karo
        console.log('Parsed start:', start);
        console.log('Parsed end:', end);

        // ✅ Format dates - LOWERCASE 'yyyy' use karo
        const startStr = start ? format(start, "MMMM D, YYYY") : "";
        const endStr = end ? format(end, "MMMM D, YYYY") : "";


        console.log('Formatted startStr:', startStr);
        console.log('Formatted endStr:', endStr);
  
        const dateRange =
          startStr && endStr ? `${startStr} to ${endStr}` : startStr || endStr || "";
        //  <h3 style=" font-size: 24px;font-weight:500; color: rgba(0, 0, 0, 0.87)">
        //     Survey Evaluation Report
        //   </h3>
        const htmlContent = `
        <link href="https://fonts.googleapis.com/css2?family=Jomhuria&display=swap" rel="stylesheet" />
    <div style="padding: 0;">
      <div style="text-align: left;">
      <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">   
          <h1 style="margin-top: -40px; margin-bottom: 10px; font-family: 'Jomhuria', cursive!important;
           text-align: left; font-size: 62px; font-weight: 550; color: rgba(0, 0, 0, 0.87); ">
            ${schoolData?.name ?? ""}
          </h1>  
          <div style="display: flex; align-items: center;">
            ${schoolData?.logo1
              ? `<img src="${schoolData.logo1}" alt="School Logo" style="height: 40px; 
              margin-left: 10px; margin-bottom:-15px" />`
              : ""
            }
          </div>
        </div>
              
         <div style="display:flex;gap:30px;margin-top:15px;
         font-family: 'Open Sans', sans-serif !important; font-size: 15px; color: rgba(0, 0, 0, 0.87); font-weight: 500;">
          <strong>${dateRange} </strong> <strong> ${coach?.name ?? ""}</strong> <strong> ${sport?.name ?? ""}</strong>  
        </div>
       
              
      </div>
    </div>
  `;

        return htmlContent;
      };
      // Build respondent header


      // Build respondent header
      // private buildRespondentHeader = (respondentName: string): string => {
      //   return `
      //     <div style="padding: 0;">
      //       <div style="background-color: #f5f5f5; padding: 15px; border-radius: 6px; margin-bottom: 20px; border-left: 4px solid #2196F3;">
      //         <h3 style="margin: 0; font-size: 18px; color: #333;">
      //           Respondent: <strong style="color: #2196F3;">${respondentName}</strong>
      //         </h3>

      //       </div>
      //     </div>
      //   `;
      // }

      private buildRespondentHeader = (respondentName: string): string => {
        return `
        <link href="https://fonts.googleapis.com/css2?family=Jomhuria&display=swap" rel="stylesheet" />
    <div style="padding: 0;">
      <div style="margin-bottom:10px;position:relative;top:-15px;">
        <h3 style="font-family: 'Jomhuria', cursive!important;
        font-size:46px;font-weight:550; color: rgba(0, 0, 0, 0.87);">
          Respondent: ${respondentName}
        </h3>
      </div>
    </div>
  `;
      }

      // Build response sections separately
      private buildResponseSections = (
        surveyResponse: any,
        idx: number,
        currentResponse: any
      ): Array<{ name: string; html: string }> => {
        const { isParentModal = "false" } = this.props;
        const sections = [];

        if (isParentModal === "true") {
          const parentHtml = this.buildScaleQuestionsHtml(
            this.filterScaleCategory(
              surveyResponse.scaleSurveyQuestionResponses,
              TemplateQuestionCategory.parent
            ),
            "Parent Responses",
            currentResponse.id
          );
          if (parentHtml) {
            sections.push({ name: 'parent', html: parentHtml });
          }
        } else {
          const expectationsHtml = this.buildScaleQuestionsHtml(
            this.filterScaleCategory(
              surveyResponse.scaleSurveyQuestionResponses,
              TemplateQuestionCategory.expectations
            ),
            "Expectations",
            currentResponse.id
          );
          if (expectationsHtml) {
            sections.push({ name: 'expectations', html: expectationsHtml });
          }

          const warmthHtml = this.buildScaleQuestionsHtml(
            this.filterScaleCategory(
              surveyResponse.scaleSurveyQuestionResponses,
              TemplateQuestionCategory.warmth
            ),
            "Relational Warmth",
            currentResponse.id
          );
          if (warmthHtml) {
            sections.push({ name: 'warmth', html: warmthHtml });
          }

          const otherHtml = this.buildScaleQuestionsHtml(
            this.filterScaleCategory(
              surveyResponse.scaleSurveyQuestionResponses,
              TemplateQuestionCategory.other
            ),
            "Other",
            currentResponse.id
          );
          if (otherHtml) {
            sections.push({ name: 'other', html: otherHtml });
          }
        }

        const writtenQuestionsHtml = this.buildWrittenQuestionsHtml(
          surveyResponse.writtenQuestionsResponses,
          currentResponse.id
        );
        if (writtenQuestionsHtml) {
          sections.push({ name: 'written', html: writtenQuestionsHtml });
        }

        return sections;
      }

      private buildScaleQuestionsHtml = (
        data: any[],
        heading: string,
        surveyResponseId: number
      ) => {
        if (data.length === 0) {
          return '';
        }

        const rows = data.map((d) => {
          const response = d.responses.find((dr: any) => dr.surveyResponseId === surveyResponseId);
          const value = response ? roundToTen(response.response) : '';

          return `
      <tr>
        <td style="font-family: 'Open Sans', sans-serif !important; font-weight: normal; 
        padding:0px 10px 5px 0px; border: 1px solid #ddd;border-left:none;color:#000;line-height:17px; font-size: 12px;">${d.question.text}</td>
        <td style="font-family: 'Open Sans', sans-serif !important; padding:1px 10px 5px 10px; 
        border: 1px solid #ddd;color:#000; text-align: center; width: 80px; font-weight: bold; 
        font-size: 12px;">${value}</td>
      </tr>
    `;
        }).join('');

        return `
    <div style="margin-bottom: 25px; page-break-inside: avoid;">
      <table style="width: 100%; border-collapse: collapse; border: none; margin-top: 8px;">
        <thead>
          <tr style="background-color:${this.props.schoolData?.primaryColor ?? "#2196F3"}; color: white;">
            <th style="padding:1px 10px 5px 10px; font-familyOswald, Arial, sans-serif;border-bottom: 2px solid #000; border-top: 2px solid #000; text-align: left; font-size: 17px;">${heading}</th>
            <th style="padding:1px 10px 5px 10px;border-left:1px solid #ddd; font-familyOswald, Arial, sans-serif;border-top: 2px solid #000; border-bottom: 2px solid #000; 
            text-align: center; width: 80px; font-size: 14px;">Value</th>
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    </div>
  `;
      }

      private buildWrittenQuestionsHtml = (
        data: any[],
        surveyResponseId: number
      ) => {
        const questions = data
          .filter((d) => d.question.text)
          .map((d) => {
            const response = d.responses.find((dr: any) => dr.surveyResponseId === surveyResponseId);
            const responseText = response?.response || 'No response';

            return `
        <div style="margin-bottom: 20px; page-break-inside: avoid;">
          <div style="font-weight: bold; margin-bottom: 8px; font-size: 14px; color: #333;">
            ${d.question.text}
          </div>
          <div style="background-color: #f9f9f9; border: 1px solid #ccc; 
          border-left: 4px solid color: ${this.props.schoolData?.primaryColor ?? "#2196F3"};; 
          border-radius: 4px;text-align:left; padding:2px 5px 5px 5px;word-wrap:break-word; font-size: 13px;">
            ${responseText}
          </div>
        </div>
      `;
          })
          .join('');

        return questions ? `
    <div style="margin-top: 25px; page-break-inside: avoid;">
     
      <h4 style="margin: 0 0 15px 0; font-size: 18px; font-weight: bold; color: #333; border-bottom: 2px solid color: ${this.props.schoolData?.primaryColor ?? "#2196F3"}; padding-bottom: 6px;">
        Written Responses
      </h4>
      ${questions}
    </div>
  ` : '';
      }

      // // Add this helper method if it doesn't exist
      // private filterScaleCategory = (data: any[], category: TemplateQuestionCategory) => {
      //   return data.filter((item) => item.question.category === category);
      // }
      //  ============= END PDF FUNCTIONALITY =============

      private readonly loadAsync = async () => {
        const { isParentModal = "false" } = this.props;

        await this.runCancellableStatefulAsync(
          this,
          {
            loading: true,
          },
          {
            loading: undefined,
          },
          async () => {
            const { surveyId, coach } = this.props;
            const surveyResponse = await this.buildGetWithParams<
              ISurveyEvaluationResponses,
              ISurveyEvaluationRequest
            >(
              this,
              l`survey/${surveyId}/evaluations/${coach.id}`
            )({
              isParentResponses: isParentModal,
              schoolSlug: this.props.slug,
            });
            this.setState({ surveyResponse });
          },
          () => {
            this.setState({
              loading: undefined,
            });
          }
        );
      }

    }
  )
);



// WEBPACK FOOTER //
// ./src/features/director/pages/evaluation/SurveyResponsesModal.tsx